import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import WorkerPoolCycleAction from "views/Account/WorkerPool/CycleAction";
import { showCycleConfirmation } from "views/Account/WorkerPool/CycleConfirmation";
import WorkerPoolDeleteAction from "views/Account/WorkerPool/DeleteAction";
import { showDeleteConfirmation } from "views/Account/WorkerPool/DeleteConfirmation";
import WorkerPoolResetAction from "views/Account/WorkerPool/ResetAction";
import { showResetConfirmation } from "views/Account/WorkerPool/ResetConfirmation";
import WorkerPoolUpdateAction from "views/Account/WorkerPool/UpdateAction";
import { showWorkerPoolFormDrawer } from "views/Account/WorkerPools/CreateWorkerPool";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableDropdownCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  if (row.kind === "public") {
    return <TableSimpleCell {...cellProps} />;
  }

  const { workerPool } = row;

  const handleEdit = () => {
    showWorkerPoolFormDrawer({
      id: workerPool.id,
      workerPool,
      refetchQuery: "SearchWorkerPools",
    });
  };

  const handleOnCycle = () => {
    showCycleConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  const handleOnReset = () => {
    showResetConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  const handleOnDelete = () => {
    showDeleteConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Worker pool actions" dotsSize="small">
        <CopyFieldDropdownMenuItem title="Copy ID" value={workerPool.id} />
        <WorkerPoolUpdateAction onAction={handleEdit} workerPool={workerPool} />
        <WorkerPoolCycleAction onAction={handleOnCycle} workerPool={workerPool} />
        <WorkerPoolResetAction onAction={handleOnReset} workerPool={workerPool} />
        <WorkerPoolDeleteAction onAction={handleOnDelete} workerPool={workerPool} />
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableDropdownCell;
